package com.qrkontaq.ui.admin

object AdminStringsPt : AdminStrings {
    override val tabDashboard = "Resumo"
    override val tabDashboardSub = "O que está acontecendo no seu estabelecimento hoje"
    override val tabMenu = "Cardápio"
    override val tabMenuSub = "Categorias, pratos, preços e esgotados"
    override val tabStopList = "Esgotados"
    override val tabStopListSub = "Acabou o prato? Um toque"
    override val tabTables = "Mesas"
    override val tabTablesSub = "Chamadas do salão e QR codes para imprimir"
    override val tabStaff = "Equipe"
    override val tabStaffSub = "Convites e papéis da equipe"
    override val tabSettings = "Ajustes"
    override val tabSettingsSub = "Marca, contatos, horário de funcionamento"
    override val tabSubscription = "Assinatura"
    override val tabSubscriptionSub = ""

    override val openSite = "Abrir site"
    override val logout = "Sair"
    override val viewSite = "ver o site"
    override val roleOwner = "Dono"
    override val roleManager = "Gerente"
    override val roleWaiter = "Garçom"
    override val roleCook = "Cozinheiro"
    override val roleBartender = "Bartender"
    override val roleStaff = "Funcionário"

    override val interfaceLanguage = "Idioma do painel"
    override val pastDueBanner = "O período pago terminou. Os recursos Pro ainda funcionam por alguns dias."
    override val pay = "Pagar"
    override val statScans = "Escaneios de QR"
    override val periodToday = "Hoje"
    override val periodWeek = "Semana"
    override val periodMonth = "Mês"
    override val periodYear = "Ano"
    override val prevPeriod = "Período anterior"
    override val nextPeriod = "Próximo período"
    override val statVisits = "Visitas"
    override val statRevenue = "Faturamento"
    override val statRating = "Nota"
    override val statDishLikes = "Curtidas de pratos"
    override val statCookedOrders = "Pedidos preparados"
    override val statCookedDishes = "Pratos preparados"
    override val statDrinksMade = "Bebidas preparadas"
    override val statServedOrders = "Pedidos aceitos"
    override val statServedDishes = "Itens aceitos"
    override val statTablesServed = "Mesas atendidas"
    override val myDishesCooked = "O que você preparou"
    override val myDrinksMade = "Bebidas que você fez"
    override val myDishesServed = "O que você aceitou"
    override val myTablesTitle = "Mesas"
    override val myTimelineTitle = "Linha do tempo"
    override val myWorkEmpty = "Ainda não há dados neste período"
    override val scansByDay = "Evolução dos escaneios"
    override fun maxBadge(value: String) = "máx. $value"
    override val peakHours = "Horários de pico (escaneios)"
    override val scansByTable = "Escaneios por mesa"
    override val withoutTable = "sem mesa"
    override fun tableN(label: String) = "Mesa $label"
    override val topDishes = "Pratos favoritos dos clientes"
    override val soldProducts = "Produtos vendidos"
    override val dashEmptyTables = "Ainda não há escaneios"
    override val dashEmptyTablesHint = "Imprima os QR codes das mesas — as estatísticas de cada mesa vão aparecer aqui"
    override val dashEmptySales = "Ainda não há vendas"
    override val dashEmptySalesHint = "Assim que os clientes começarem a pedir, o faturamento por prato aparece aqui"
    override val dashEmptyTop = "Ainda não há curtidas"
    override val dashEmptyTopHint = "Os clientes podem curtir pratos no cardápio — os favoritos vão aparecer aqui"
    override val dashEmptyCallsHint = "Não houve chamadas neste período"
    override val dashEmptyPeakHint = "Os dados aparecem depois dos primeiros escaneios de QR"

    override val tabOrders = "Pedidos"
    override val tabOrdersSub = "Cozinha e salão: status dos pratos em tempo real"
    override val statusNew = "Novo"
    override val statusCooking = "Preparando"
    override val statusReady = "Pronto"
    override val statusServed = "Servido"
    override val takeOrder = "Começar a preparar"
    override val markReady = "Pronto"
    override val markServed = "Servido"
    override val newOrderTitle = "Novo pedido"
    override val addOrderBtn = "Adicionar pedido"
    override val addDishesHint = "Adicione pratos do cardápio"
    override val totalLabel = "Total"
    override val markPaid = "Pago"
    override val confirmPaid = "Marcar como pago e liberar a mesa?"
    override val tableFree = "Livre"
    override val noActiveOrders = "Nenhum pedido ativo"
    override val ordersColumnEmpty = "Vazio"
    override fun orderTakenBy(name: String) = "Aceito por $name"
    override val orderOtherWaiter = "Pedido de outro garçom"
    override val closeMixedTableHint = "Esta mesa tem um pedido de outro garçom — um gerente pode fechá-la"
    override val waitingWaiter = "Aguardando o garçom"
    override val closeLabel = "Fechar"
    override fun minutesShort(min: Long) = "$min min"
    override fun agoShort(min: Long) = when {
        min < 60 -> "$min m"
        min < 1440 -> "${min / 60} h"
        else -> "${min / 1440} d"
    }
    override val orderStepBack = "Voltar uma etapa"
    override val authCabinet = "O painel do seu estabelecimento"
    override val authRegisterSub = "Crie uma conta para entrar"
    override val authShopName = "Nome do restaurante"
    override val authShopNamePh = "Café «Aconchego»"
    override val authDomain = "Domínio"
    override val authDomainPh = "aconchego"
    override val authPassword = "Senha"
    override val authSignIn = "Entrar"
    override val authCreateAccount = "Criar conta"
    override val authCreateShop = "Criar o estabelecimento"
    override val authWizardSub = "Último passo: crie o seu estabelecimento"
    override val authNoShop = "Ainda não tem um estabelecimento? Cadastre-se"
    override val authHaveAccount = "Já tem cadastro? Entrar"
    override val authNoAccount = "Não tem conta? Cadastre-se"
    override val authOr = "ou"
    override val authBack = "Voltar"
    override val authContinueGoogle = "Continuar com Google"
    override val authContinueApple = "Continuar com Apple"
    override val authLoginFailed = "Email ou senha incorretos."
    override val authRegisterFailed = "Não foi possível fazer o cadastro. Verifique os dados."
    override val authErrEmailInvalid = "Digite um email válido — por exemplo, you@example.com."
    override val authErrEmailTaken = "Este email já está cadastrado. Tente entrar."
    override val authErrDomainTaken = "Este endereço de site já está em uso — escolha outro."
    override val authErrDomainRules =
        "Endereço do site: 3–30 caracteres, apenas letras latinas, números e hífen; deve começar e terminar com letra ou número."
    override val authPasswordHint = "Mínimo de 6 caracteres"
    override val authErrPasswordRules =
        "A senha é muito curta: mínimo de 6 caracteres."
    override val authErrInvalidCredentials = "Email ou senha incorretos."
    override val authErrOauthAccount = "Esta conta entra com Google/Apple — use esse botão de login."
    override val authErrOauthEmailTaken = "Este email já está registado com palavra-passe — inicie sessão com email e palavra-passe."
    override val authErrDeactivated = "Esta conta foi desativada. Fale com o suporte."
    override val authErrDomainReserved = "Este endereço é reservado pelo sistema — escolha outro."
    override val authErrNameRules = "Nome do estabelecimento: de 1 a 100 caracteres."
    override val brandTagline = "Seu próprio site em 1 minuto — e comece a usar na hora"
    override val brandFeature1 = "Cardápio QR em vários idiomas"
    override val brandFeature2 = "Salão e cozinha em tempo real"
    override val brandFeature3 = "Estatísticas, esgotados e equipe"
    override val brandFeature4 = "Pedidos, contas e pagamento"
    override val brandFeature6 = "Plano grátis, sem cartão"
    override val inviteWelcome = "Entrando na equipe"
    override val inviteAccepting = "Aceitando o convite…"
    override fun inviteJoined(role: String) = "Você entrou como $role"
    override val inviteGoCabinet = "Ir para o painel"
    override val inviteInvalid = "O convite é inválido ou expirou"
    override val inviteLoginHint = "Entre ou cadastre-se para aceitar o convite"
    override val hallCalls = "Chamadas do salão"
    override val legendWaiter = "Garçom"
    override val legendBill = "Conta"
    override val asksBill = "pede a conta"
    override val callsWaiter = "chama o garçom"
    override val done = "Concluído"
    override val markedDone = "Marcado como concluído"
    override val callUpdateFailed = "Não foi possível atualizar a chamada"
    override val layoutSaveFailed = "Não foi possível salvar a disposição das mesas"
    override val bootFailed = "Não foi possível conectar ao servidor. Verifique sua internet e tente de novo."
    override val bootRetry = "Tentar de novo"

    override fun inStop(count: Int) = "Esgotados: $count"
    override fun totalDishes(count: Int) = "Total de pratos: $count"
    override val searchDishPh = "Buscar prato…"
    override val nothingFound = "Nada encontrado"
    override val tryAnotherQuery = "Tente outra busca"
    override val outOfStock = "esgotado"
    override fun backInMenu(name: String) = "«$name» voltou ao cardápio"
    override val putToStop = "Marcado como esgotado"
    override val updateFailed = "Não foi possível atualizar"

    override val addTableTitle = "Adicionar mesa"
    override val tableLabelPh = "Ex.: 5 ou Terraço 2"
    override val add = "Adicionar"
    override val addTableFailed = "Não foi possível adicionar a mesa"
    override fun tablesCount(count: Int) = "Mesas ($count)"
    override val qrPdf = "QR em PDF"
    override val preparingPdf = "Preparando o PDF…"
    override fun deleteTable(label: String) = "Excluir mesa $label"
    override fun deleteTableConfirm(label: String) = "Excluir a mesa $label?"
    override val planHint = "Arraste as mesas para organizá-las como no salão. A disposição fica salva neste navegador."
    override val noTablesTitle = "Ainda não há mesas"
    override val noTablesHint = "Adicione mesas — e geramos um PDF com QR codes para imprimir"

    override val inviteTitle = "Convidar funcionário"
    override val inviteHint = "Garçom — mesas e pedidos. Cozinheiro — pedidos (mesas só para ver). Gerente — tudo, menos a assinatura."
    override val createInvite = "Criar convite"
    override val inviteCreated = "Convite criado"
    override val inviteCreateFailed = "Não foi possível criar o convite"
    override val copy = "Copiar"
    override val copied = "Copiado"
    override fun teamCount(count: Int) = "Equipe ($count)"
    override val removeFromTeam = "Remover da equipe"
    override val removeFromTeamConfirm = "Remover da equipe?"
    override val activeInvites = "Convites ativos:"
    override fun validUntil(date: String) = "válido até $date"
    override val cancel = "Cancelar"
    override val teamMembersWord = "membros"
    override fun teamMemberSince(date: String) = "na equipe desde $date"
    override val permWaiter = "Mesas e pedidos"
    override val permCook = "Pedidos da cozinha"
    override val permBartender = "Pedidos do bar"
    override val permManager = "Tudo, menos a assinatura"
    override val barCategory = "Categoria de bar (bebidas)"
    override val barBadge = "Bar"

    override val currentState = "Status atual"
    override fun activeUntil(date: String) = "Ativa até $date"
    override val pastDueLong = "Pagamento atrasado — os recursos Pro serão pausados em breve"
    override val badgeActive = "Ativa"
    override val badgePastDue = "Atrasada"
    override val plan1Month = "1 mês"
    override val plan3Months = "3 meses"
    override val plan12Months = "12 meses"
    override val bestValueBadge = "-17% · mais vantajoso"
    override val payMono = "Escolher"
    override val autoRenewLabel = "Renovação automática"
    override val autoRenewHint = "O cartão fica salvo após o pagamento e a assinatura renova automaticamente. Você pode desativar quando quiser."
    override val autoRenewActive = { mask: String? ->
        "Renovação automática ativada" + (mask?.let { " · cartão •••• $it" } ?: "")
    }
    override val autoRenewDisable = "Desativar"
    override val planActiveTitle = "Plano ativado"
    override val nextChargeOn = { date: String, amount: String -> "Próxima cobrança $date · $amount" }
    override val autoRenewOffNote = { date: String -> "Renovação automática desativada — o acesso vale até $date" }
    override val cancelSubscription = "Cancelar assinatura"
    override val resumeAutoRenew = "Retomar a renovação automática"
    override val subActiveOverline = "Assinatura ativa"
    override val subEyebrow = "Planos"
    override val subChooseTitle = "Free ou Pro"
    override val subChooseSub = "Cardápio, pedidos e mesas — grátis para sempre. O Pro libera os serviços para clientes e a equipe."
    override val subFeaturesCap = "Incluído no Pro"
    override val subFeatures = listOf(
        "Programa de fidelidade com cashback",
        "Botão de chamar o garçom",
        "Conta da mesa para os clientes",
        "Cardápio em vários idiomas",
        "Seções «Popular» e «O chef recomenda»",
        "Equipe e convites de funcionários",
    )
    override val subCtaSubscribe = "Mudar para o Pro"
    override val trustCancel = "Cancele quando quiser"
    override val trustSecure = "Pagamento seguro"

    override val planFree = "Free"
    override val planPro = "Pro"
    override val planFreeSub = "cardápio sem limites"
    override val planCurrent = "Seu plano"
    override val planRecommended = "Recomendado"
    override val perMonth = "por mês"
    override val proLockTitle = "Disponível no Pro"
    override val proLockTeamBody = "Convide garçons, cozinheiros e gerentes no plano Pro. Os membros atuais da equipe permanecem."
    override val proUpgradeCta = "Mudar para o Pro"
    override val proSectionHint = "Disponível no plano Pro — ative na aba «Assinatura»."
    override val proLangHint = "No Free há um idioma de cardápio ativo — troque quando quiser. O Pro libera todos os idiomas."
    override val payHint = "Pagamento pela página segura do monobank. Depois do pagamento, a assinatura renova automaticamente."
    override val paymentHistory = "Histórico de pagamentos"

    override val newCategory = "Nova categoria"
    override val addCategory = "Adicionar categoria"
    override val hiddenBadge = "oculta"
    override val showLabel = "Mostrar"
    override val hideLabel = "Ocultar"
    override val moreActions = "Mais ações"
    override val moveUp = "Para cima"
    override val moveDown = "Para baixo"
    override val deleteCategory = "Excluir categoria"
    override fun deleteCategoryConfirm(name: String) = "Excluir a categoria «$name» junto com os pratos?"
    override val addDishPlus = "＋ Adicionar prato"
    override val copySuffix = " (cópia)"
    override val duplicate = "Duplicar"
    override val dishDuplicated = "Prato duplicado"
    override val duplicateFailed = "Não foi possível duplicar"
    override val edit = "Editar"
    override val delete = "Excluir"
    override fun deleteDishConfirm(name: String) = "Excluir «$name»?"
    override val dishDeleted = "Prato excluído"
    override val deleteFailed = "Não foi possível excluir"
    override val dangerZoneTitle = "Zona de risco"
    override val dangerZoneHint =
        "Excluir o estabelecimento é permanente: somem o cardápio, as fotos, as mesas, os pedidos, a equipe, a fidelidade e o endereço do site."
    override val deleteVenueButton = "Excluir estabelecimento"
    override val deleteVenueModalTitle = "Excluir este estabelecimento?"
    override val deleteVenueModalBody =
        "Isso não pode ser desfeito. Serão excluídos para sempre o cardápio e as fotos, as mesas e os QR codes, " +
            "os pedidos e as estatísticas, a equipe e os convites, o programa de fidelidade e o endereço do site."
    override fun deleteVenueConfirmLabel(name: String) = "Para confirmar, digite o nome «$name»"
    override val deleteVenueConfirmPlaceholder = "Nome do estabelecimento"
    override val deleteVenueConfirmCta = "Excluir para sempre"
    override val deleteVenueSuccess = "Estabelecimento excluído"
    override val stopBadge = "esgotado"
    override val descriptionLabel = "Descrição"
    override val descriptionPh = "Ex.: Tomate, muçarela, manjericão fresco"
    override val priceLabel = "Preço"
    override val weightLabel = "Peso/volume"
    override val weightPh = "320 g"
    override val kcalLabel = "Kcal"
    override val tagsLabel = "Tags"
    override val allergensLabel = "Alérgenos"
    override val tagVegan = "Vegano"
    override val tagSpicy = "Picante"
    override val tagNew = "Novidade"
    override val allergenGluten = "Glúten"
    override val allergenLactose = "Lactose"
    override val allergenNuts = "Frutos secos"
    override val allergenEggs = "Ovos"
    override val allergenFish = "Peixe"
    override val allergenSoy = "Soja"
    override val chefRecommends = "O chef recomenda"
    override val uploadingEllipsis = "Enviando…"
    override val addPhoto = "Adicionar foto"
    override val replacePhoto = "Trocar foto"
    override val photoUploadFailed = "Não foi possível enviar a foto"
    override val addDish = "Adicionar prato"
    override val save = "Salvar"
    override val dishAdded = "Prato adicionado"
    override val savedToast = "Salvo"
    override val saveFailed = "Não foi possível salvar"
    override val menuStatCategories = "categorias"
    override val menuStatDishes = "pratos"
    override val menuStatFeatured = "destaques"
    override val menuEmptyTitle = "O cardápio ainda está vazio"
    override val menuEmptyHint = "Crie a primeira categoria — e comece a adicionar pratos."
    override val categoryLabel = "Categoria"
    override val editCategory = "Editar categoria"
    override val editDish = "Editar prato"
    override val noCategory = "Sem categoria"

    override val sitePreviewTitle = "Como o site vai ficar"
    override val sitePreviewHint = "A prévia atualiza na hora — salve para aplicar no site."
    override val restaurantNamePh = "Nome do estabelecimento"
    override val brandTitle = "Marca"
    override val logoLabel = "Logo"
    override val coverLabel = "Capa"
    override val nameLabel = "Nome"
    override val shortDescription = "Descrição curta"
    override val accentHint = "Cor de destaque — botões, preços e realces no site do estabelecimento"
    override val customColorLabel = "Ou uma cor personalizada"
    override val contactsTitle = "Contatos"
    override val addressLabel = "Endereço"
    override val mapPickHint = "Arraste o mapa até o marcador apontar para o estabelecimento"
    override val mapFindByAddress = "Buscar pelo endereço"
    override val mapUseLocation = "Minha localização"
    override val phoneLabel = "Telefone"
    override val socialsHint = "Redes sociais — aparecem para os clientes na seção «Sobre nós» do site"
    override val workingHoursTitle = "Horário de funcionamento"
    override val workingHoursHint = "Vazio = fechado. Formato 09:00 / 22:00, também vale passar da meia-noite (18:00–02:00)."
    override val dayMon = "Seg"
    override val dayTue = "Ter"
    override val dayWed = "Qua"
    override val dayThu = "Qui"
    override val dayFri = "Sex"
    override val daySat = "Sáb"
    override val daySun = "Dom"
    override val dayOff = "fechado"
    override val siteThemeTitle = "Tema do site"
    override val siteThemeHint = "Como o cardápio aparece para o cliente: claro, escuro ou automático conforme o celular."
    override val themeAuto = "Auto (como o do cliente)"
    override val themeLight = "Claro"
    override val themeDark = "Escuro"
    override val menuLookTitle = "Aparência do cardápio"
    override val categoryPhotosTitle = "Fotos nas categorias"
    override val categoryPhotosHint = "O chip da categoria mostra a foto do primeiro prato; sem foto — só texto"
    override val featureFirstTitle = "Primeiro prato em card grande"
    override val featureFirstHint = "O primeiro prato da categoria ganha foto em largura total; desligado — igual aos outros"
    override val showPopularTitle = "Seção «Populares»"
    override val showPopularHint = "Mostrar uma seleção de pratos populares no topo do cardápio"
    override val showChefTitle = "Seção «O chef recomenda»"
    override val showChefHint = "Mostrar uma seleção de pratos que o chef recomenda"
    override val showFiltersTitle = "Botão de filtros"
    override val showFiltersHint = "Mostrar o botão de filtros ao lado das categorias do cardápio"
    override val menuLanguagesTitle = "Idiomas do cardápio"
    override val menuLanguagesHint = "O cliente pode alternar esses idiomas no site. Preencha nomes e descrições nos idiomas escolhidos."
    override val saveChanges = "Salvar alterações"
    override val savedCheck = "Salvo ✓"
    override val savedSiteUpdated = "Salvo — o site foi atualizado"
    override val saveFailedCheckColor = "Não foi possível salvar (verifique a cor #RRGGBB)"
    override val upload = "Enviar"
    override val replace = "Trocar"

    override val currencyTitle = "Moeda"
    override val currencyHint = "Moeda dos preços do cardápio e dos bônus dos clientes."
    override val guestServicesTitle = "Serviços na mesa"
    override val guestServicesHint = "O que o cliente vê na página da mesa depois de escanear o QR"
    override val guestCheckTitle = "Mostrar a conta ao cliente"
    override val guestCheckHint = "O cliente vê sua conta em tempo real: itens, quantidade e total"
    override val waiterCallTitle = "Chamada de garçom"
    override val waiterCallHint = "O cliente pode chamar o garçom ou pedir a conta"
    override val loyaltyTitle = "Programa de fidelidade"
    override val loyaltyEnableTitle = "Cashback para clientes"
    override val loyaltyEnableHint = "O cliente acumula bônus a cada conta e os usa na hora de pagar"
    override val loyaltyRateLabel = "Porcentagem de cashback da conta (1–50)"
    override val loyaltyRateHint = "Essa parte do valor da conta volta para o cliente em bônus"
    override val loyaltyGuestTitle = "Bônus do cliente"
    override val loyaltyCandidatesTitle = "Escanearam esta mesa há pouco"
    override val loyaltyCodePh = "Código de 6 dígitos"
    override val loyaltyScanQr = "Escanear QR"
    override val loyaltyFindGuest = "Encontrar cliente"
    override val loyaltyCodeNotFound = "Código não encontrado"
    override val loyaltyCodeExpired = "Código expirado — peça ao cliente para mostrar um novo"
    override val loyaltyCheckFailed = "Não foi possível verificar o código"
    override val loyaltyBalanceLabel = "Saldo"
    override val loyaltyRedeemLabel = "Usar bônus"
    override val loyaltyEarnedLabel = "Acumulado"
    override val loyaltyRedeemedLabel = "Usado"
    override val loyaltyNewBalanceLabel = "Novo saldo"
    override val loyaltyClear = "Limpar"
    override val loyaltyCameraFailed = "Câmera indisponível — digite o código manualmente"
    override val loyaltyGuestAtTable = "Cliente na mesa"
    override val loyaltyNewGuest = "Novo cliente"
    override val loyaltyVisitsSuffix = "visitas"
    override val loyaltyCallingWaiter = "Chamando o garçom"
    override val loyaltyCallingBill = "Pedindo a conta"
}
